var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoitNavigator = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4359 13.6061C26.208 14.3933 26.1844 15.6482 25.384 16.4306C24.5968 17.1999 23.3015 17.1867 22.5482 16.4014C21.7968 15.6189 21.8214 14.301 22.6001 13.5581C23.3995 12.7954 24.6619 12.8171 25.4359 13.6071V13.6061Z",
    fill: "#3187FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9901 18.9198C20.0232 15.1771 20.0043 11.4344 19.9996 7.69167C19.9977 6.40384 19.1542 5.50094 17.9862 5.5C16.8239 5.5 15.9851 6.41327 15.9842 7.69544C15.9832 9.31348 15.9917 10.9315 15.9964 12.643C15.7096 12.5373 15.5162 12.4637 15.3209 12.3958C11.9613 11.2212 8.25533 12.7533 6.70333 15.9592C5.15888 19.15 6.22783 22.9899 9.22521 24.8712C11.5367 26.3222 13.9595 26.4232 16.3436 25.1165C18.7532 23.7956 19.9656 21.6653 19.9901 18.9198ZM10.8263 21.0624C9.73279 19.8812 9.77714 17.9113 10.9206 16.8423C12.132 15.7111 14.0718 15.7696 15.1728 16.9706C16.2842 18.183 16.221 20.0614 15.0322 21.1634C13.8331 22.2757 11.9065 22.2295 10.8253 21.0615L10.8263 21.0624Z",
    fill: "#3187FA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoitNavigator);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/doit-navigator.ad547ab7e864bbe997b285e1dc3d8de2.svg";